import type { Theme } from "@mui/material/styles";
import { experimental_extendTheme as extendTheme } from "@mui/material/styles";

import { setFont } from "./styles/utils";
import { overridesTheme } from "./overrides-theme";
import type { SettingsState, ThemeLocaleComponents } from "./types";
import {
	shadows,
	typography,
	components,
	colorSchemes,
	customShadows,
} from "./core";

// ----------------------------------------------------------------------

function shouldSkipGeneratingVar(keys: string[]): boolean {
	const skipGlobalKeys = [
		"mixins",
		"overlays",
		"direction",
		"breakpoints",
		"cssVarPrefix",
		"unstable_sxConfig",
		"typography",
		// 'transitions',
	];

	const skipPaletteKeys: Record<string, string[]> = {
		global: ["tonalOffset", "dividerChannel", "contrastThreshold"],
		grey: ["A100", "A200", "A400", "A700"],
		text: ["icon"],
	};

	const isPaletteKey = keys[0] === "palette";

	if (isPaletteKey) {
		const paletteType = keys[1];
		const skipKeys = skipPaletteKeys[paletteType] || skipPaletteKeys.global;

		return keys.some((key) => skipKeys?.includes(key));
	}

	return keys.some((key) => skipGlobalKeys?.includes(key));
}

// ----------------------------------------------------------------------

export function createTheme(
	localeComponents: ThemeLocaleComponents,
	settings: SettingsState,
): Theme {
	const initialTheme = {
		colorSchemes,
		shadows: shadows(settings.colorScheme ?? "light"),
		customShadows: customShadows(settings.colorScheme ?? "light"),
		direction: settings.direction || "ltr",
		shape: { borderRadius: 8 },
		components,
		typography: {
			...typography,
			fontFamily: setFont(settings.fontFamily),
		},
		cssVarPrefix: "",
		shouldSkipGeneratingVar,
	};

	const theme = extendTheme(initialTheme, localeComponents, overridesTheme);

	return theme;
}
